const insuranceCollection = require('od-modules/collections/insurance_catalogue.collection').getInstance();

const CANCELLATION_POLICY = 'CNXFLT151';

const getInsurancePolicy = () => CANCELLATION_POLICY;

const getInsurance = () => insuranceCollection.getInsuranceByPolicy(getInsurancePolicy());

const checkPolicyExists = ({policy} = {}) => policy === getInsurancePolicy();

const getId = ({id} = {}) => id;

const getInsuranceId = () => getId(getInsurance());

module.exports = {
    getInsurance,
    getInsurancePolicy,
    getInsuranceId,
    isInsuranceAvailable: () => checkPolicyExists(getInsurance()),
};
